export enum FeedbackCommentsFilterOptionEnum {
  all = 'ALL',
  today = 'TODAY',
  thisMonth = 'THIS_MONTH',
  chooseRange = 'DATE'
}
